import {Swappable} from '@shopify/draggable';

import SoundFx from '../../../components/SoundFx';

export default function HeroSection(HeroPuzzle, Hero) {
  const containers = document.querySelectorAll('.CubesFrame--idHero .Cube');
  const draggable = new Swappable(containers);
  let swappedNode = null;

  // --- Drag states --- //
  draggable.on('drag:start', (evt) => {
    evt.sensorEvent.originalEvent.preventDefault();
    SoundFx.Synth.play('up');
  });

  draggable.on('drag:over', (evt) => {
    if (evt.source.getAttribute('data-face') !== evt.over.getAttribute('data-face')) {
      evt.cancel();
    }
  });

  draggable.on('swappable:swapped', ({swappedElement}) => {
    swappedNode = swappedElement;
    SoundFx.Synth.play('swap');
  });

  draggable.on('drag:stop', (evt) => {
    if (!swappedNode || evt.sourceContainer.contains(evt.source)) {
      SoundFx.Synth.play('downBad');
      return;
    }

    const swapData = HeroPuzzle.getSwapData(Hero.progress, evt.source, swappedNode);

    SoundFx.Synth.play('downGood');
    Hero.updateProgress(swapData);
    Hero.checkSolutions(draggable);

    swappedNode = null;
  });

  return draggable;
}
